<template>
    <div class="rush-order-apply-process">
        <div class="ro-process-section">
            <div class="ro-process-title">法人供应商平台抢单权限申请指引</div>
            <div class="ro-process-steps">
                <img :src="lc1" alt="">
                <img :src="lc2" alt="">
            </div>
            <div class="ro-tips">
                <div>申请说明：</div>
                <div>（1）申请抢单权限：登陆LSP供应商管理系统- -平台抢单权限申请（①智汇签完成补充协议签署；②补齐缺失或失效的证照资料），点击提交申请即可。</div>
                <div>（2）查阅货源报价：登录微信小程序“安得网货”查看货源和报价。</div>
                <div>（3）平台撮合交易规则说明：</div>
                <div>①报价方式：货源订单的报价方式包含按“吨/元”、“方/元”、“竞价模式”三种类型，具体报价方式以安得调度发布的货源订单为准。</div>
                <div>②履约保证金：货源订单履约保证金有五个档位，分别为200元/300元/400元/500元/1000元；在正常报价和完成运输履约情况下无需缴纳履约保证金，若出现违约责任，则在主运输合同下未结算运费扣除相应金额的履约保证金。</div>
                <div>③结算方式：每个货源订单的运费以最终成交的金额为准，结算账期与运输主合同账期一致，包含对账、开票等要求。</div>
            </div>
        </div>
        <div class="ro-button-wrap">
            <el-button @click="handleRecord">申请记录</el-button>
            <el-button type="primary" @click="handleApply">立即申请</el-button>
        </div>
        <RecordDialog ref="recordRef" />
    </div>
</template>
<script>
import RecordDialog from './RecordDialog.vue';
import { TABS } from './config.js';
import lc1 from './imgs/lc1.png';
import lc2 from './imgs/lc2.png';

export default {
    components: { RecordDialog },
    data() {
        return {
            lc1,
            lc2,
        }
    },
    methods: {
        handleApply() {
            this.$emit('valid', TABS[1])
        },
        handleRecord() {
            this.$refs.recordRef.open()
        }
    }
}
</script>
<style lang="less">
.rush-order-apply-process {
    .ro-process-section {
        height: calc(100vh - 98px);
        overflow-y: scroll;
    }
    .ro-process-title {
        text-align: center;
        font-size: 32px;
        font-weight: bold;
        padding-top: 66px;
        margin-bottom: 42px;
    }
    .ro-process-steps {
        display: flex;
        justify-content: center;
        margin-bottom: 54px;

        img {
            width: 392px;
            height: 550px;

            & + img {
                margin-left: 52px;
            }
        }
    }
    .ro-tips {
        width: 836px;
        margin: 0 auto;
        font-size: 12px;
        color: #666;
        line-height: 24px;
        padding-bottom: 36px;
    }
    .ro-button-wrap {
        text-align: center;
        padding: 12px 0;
        background-color: white;

        .el-button {
            padding: 10px 56px
        }
        .el-button + .el-button {
            margin-left: 15px;
        }
    }
}
</style>
